// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "mobileDialog__header-244Ny";
export { _1 as "__esModule", _2 as "mobileDialog__header" }
export default { "__esModule": _1, "mobileDialog__header": _2 }
